import { removeFalsy } from "helpers/formatter";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type ParamsType = Record<any, any>;

const getDefaultValueWithQueryParams = (searchParams, values) => {
  let result = { ...values };

  for (var key of Object.keys(values)) {
    let queryParamVal = searchParams.get(key);
    if (queryParamVal) result[key] = queryParamVal;
  }
  return result;
};

export const useQueryParams = <T extends ParamsType>(
  initialValue: any
): [
  T,
  (key: Extract<keyof T, any>, value: any) => void,
  T,
  (partialParams: Partial<T>) => void
] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultValue = getDefaultValueWithQueryParams(searchParams, initialValue);

  const [defaultParams, setDefaultParams] = useState(defaultValue);
  const [params, setParams] = useState(initialValue);

  const onChangeHandler = (key: Extract<keyof T, any>, value: any) => {
    setParams((p: T) => ({ ...p, [key]: value }));
  };

  const onChangeObjHandler = (obj) => {
    setParams((p: T) => ({ ...p, ...obj }));
  };

  const updateQueryParams = () => {
    setSearchParams({ ...removeFalsy(params) });
  };

  useEffect(() => {
    updateQueryParams();
  }, [params]);

  return [params, onChangeHandler, defaultParams, onChangeObjHandler];
};
